enum HoldingTankSortOptions {
  NAME_UPWARD= 'name-ascending',
  NAME_DOWNWARD= 'name-descending',
  SPONSOR_UPWARD= 'sponsor-ascending',
  SPONSOR_DOWNWARD= 'sponsor-descending',
  VOLUME_UPWARD= 'volume-ascending',
  VOLUME_DOWNWARD= 'volume-descending',
}

export default HoldingTankSortOptions;
